export enum Role {
    Admin = 'Admin',
    Sales = 'Sales'
}
